module.exports = __webpack_public_path__ + "img/avatar.330f27d9.png";